<script setup lang="ts">
import type { AcceptableValue } from 'reka-ui'
import { computed } from 'vue'
import {
    DropdownMenu,
    DropdownMenuTrigger,
    DropdownMenuContent,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuRadioGroup,
    DropdownMenuRadioItem,
} from '@/components/ui/dropdown-menu'
import { Button } from '@/components/ui/button'
import { ArrowUpDown } from 'lucide-vue-next'

const props = defineProps<{
    criteria: { label: string; value: string }[]
    modelValue: string
    show: boolean
}>()

const emit = defineEmits<{
    'update:modelValue': [value: string]
    change: []
    close: []
    open: []
}>()

const selectedLabel = computed(
    () => props.criteria.find((item) => item.value === props.modelValue)?.label ?? 'Sort by',
)

const onSortingChange = (value: AcceptableValue) => {
    emit('update:modelValue', String(value))
    emit('change')
}
</script>

<template>
    <div class="relative">
        <DropdownMenu>
            <DropdownMenuTrigger as-child>
                <Button variant="outline">
                    <ArrowUpDown class="size-4 mr-2" />
                    {{ selectedLabel }}
                </Button>
            </DropdownMenuTrigger>

            <DropdownMenuContent align="end">
                <DropdownMenuLabel>Sort by</DropdownMenuLabel>
                <DropdownMenuSeparator />

                <DropdownMenuRadioGroup :model-value="modelValue" @update:model-value="onSortingChange">
                    <DropdownMenuRadioItem
                        v-for="item in props.criteria"
                        :key="item.value"
                        :value="item.value"
                    >
                        {{ item.label }}
                    </DropdownMenuRadioItem>
                </DropdownMenuRadioGroup>
            </DropdownMenuContent>
        </DropdownMenu>
    </div>
</template>
